import { useCallback, useMemo } from 'react';
import { AuthService, CommunicationChannel } from '@ianesthesie-kit/services';
import {
  verifyEmail as verifyEmailAction,
  verifyPhoneNumber as verifyPhoneNumberAction
} from '@ianesthesie-kit/redux';
import { AppDialogType } from '@/config';
import { useTranslator } from '@ianesthesie-kit/core';

export const useCommunicationChannelProps = (type: CommunicationChannel) => {
  const { createTypeSpecificProps } = useCommunicationChannelPropsCreator();
  return useMemo(
    () => createTypeSpecificProps(type),
    [createTypeSpecificProps, type]
  );
};

export const useCommunicationChannelPropsCreator = () => {
  const translate = useTranslator();
  const createTypeSpecificProps = useCallback(
    (type: CommunicationChannel) => {
      if (type === 'phone') {
        return {
          attribute: 'phoneNumber',
          sendVerificationCodeFn:
            AuthService.getInstance().requestPhoneVerification,
          verifyActionCreator: verifyPhoneNumberAction,
          requestSentMessage:
            'patient-app.verifyPhoneNumberRequestSuccessSnackbar',
          verificationSuccessMessage:
            'patient-app.verifyPhoneNumberSuccessSnackbar',
          dialog: {
            dialogType: AppDialogType.TEL_INPUT,
            title: translate('patient-app.profile.updatePhoneModal.title'),
            message: translate('patient-app.profile.updatePhoneModal.body')
          }
        } as const;
      }

      if (type === 'email') {
        return {
          attribute: 'email',
          sendVerificationCodeFn:
            AuthService.getInstance().requestEmailVerification,
          verifyActionCreator: verifyEmailAction,
          requestSentMessage: 'patient-app.verifyEmailRequestSuccessSnackbar',
          verificationSuccessMessage: 'patient-app.verifyEmailSuccessSnackbar',
          dialog: {
            dialogType: AppDialogType.INPUT,
            title: translate('patient-app.profile.updateEmailModal.title'),
            message: translate('patient-app.profile.updateEmailModal.body')
          }
        } as const;
      }

      throw new Error(`Invalid type: ${type}`);
    },
    [translate]
  );

  return {
    createTypeSpecificProps
  };
};
